<template>
  <div class="mb-4">
    <div>
      <button class="btn btn-info btn-icon mw" @click="getEpolis">
        {{ "next" | setText("Далее") }}
      </button>
    </div>
  </div>
</template>
<script>
import {
  logger,
  errorNotify,
  toFormData,
  dateConvert,
  addMonth,
} from "@/plugins/functions";

export default {
  methods: {
    errorSimurg(error = -1) {
      switch (error) {
        case 0:
          return "Успешная обработка запроса";
          break;

        case -32504:
          return "Недостаточно привилегий для выполнения метода";
          break;
        case 0:
          return "Успешная обработка запроса";
          break;
        case 1:
          return "Ошибка в json формате";
          break;
        case 2:
          return "Договор # - не существует в базе";
          break;
        case 3:
          return "Транзакция по договору # - не существует в базе";
          break;
        case 4:
          return "По договору # - уже выдан полис";
          break;
        case 5:
          return "Ошибка в формате даты";
          break;
        case 6:
          return "Ошибка в дате поступления";
          break;
        case 7:
          return "Закрытый периоид даты поступления";
          break;
        case 8:
          return "Ошибка в дате контракта";
          break;
        case 9:
          return "Ошибка в дате начала кредита";
          break;
        case 10:
          return "Ошибка в дате окончания кредита";
          break;
        case 100:
          return "Системная ошибка при обработке запроса";
          break;

        default:
          return "Неизвестная ошибка";
          break;
      }
    },
    async getEpolis() {
      this.$loading(true);

      //INIT
      const url = `${this.currentRequest.service.api_endpoint_url}PerformTransactionRequest`;
      const method = "post";
      const headers = {
        Authorization:
          "Basic " +
          btoa(
            this.currentRequest.service.api_login +
              ":" +
              this.currentRequest.service.api_password
          ),
      };

      //DATA
      let data = {
        contract_id: this.currentRequest.exchange_id,
        contract_number: this.data.id,
        payment_date: dateConvert(this.data.start_date),
        contract_date: dateConvert(this.data.start_date),
        s_date: dateConvert(this.data.start_date),
        e_date: dateConvert(addMonth(this.data.end_date, 1)),
      };

      //REQUEST

      var instance = this.$http.create();
      delete instance.defaults.headers.common["Authorization"];
      delete instance.defaults.headers.common["bid"];
      delete instance.defaults.headers.common["localization"];
      delete instance.defaults.headers.common["shop"];
      delete instance.defaults.headers.common["device"];
      delete instance.defaults.headers.common["tab"];
      delete instance.defaults.headers.common["root"];
      delete instance.defaults.headers.common["version"];
      const config = {
        method: method,
        url: url,
        data: data,
        headers: {
          common: {
            Authorization:
              "Basic " +
              btoa(
                this.currentRequest.service.api_login +
                  ":" +
                  this.currentRequest.service.api_password
              ),
          },
        },
      };

      //REQUEST
      return instance(config)
        .then((response) => {
          this.$loading(false);
          const responseData = response.data;

          if (responseData && responseData.result == 0) {
            this.$emit("input", {
              service_request: {
                state: "confirm",
                service: "semurg",
                exchange_id: this.currentRequest.exchange_id,
                response: JSON.stringify(responseData),
                body: JSON.stringify(data),
              },
            });
          }

          this.$notify({
            title: "Система страхования",
            message: this.errorSimurg(responseData.result),
            icon: "ti-info",
            horizontalAlign: "right",
            verticalAlign: "top",
          });

          return responseData;
        })
        .catch((error) => {
          this.$loading(false);
          return errorNotify(error, this.notify);
        })
        .finally(() => {});
    },
  },
  props: ["value", "data", "currentRequest"],
};
</script>
<style>
</style>
 